module.exports = __webpack_public_path__ + "img/many-crypto-coins-falling-from-the-sky.cb7b5144.jpg";